import styled from 'styled-components';
import { minBp } from 'src/lib/theme';

export const Overlay = styled.div`
  ${({ open }) => `
    display: none;
    
    @media ${minBp('tabletLarge')} {
      display: block;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 999;
      opacity: 1;
      background-color: rgba(0, 0, 0, 0.5);
      animation: fade 0.5s linear;

      @keyframes fade {
        0% {
          opacity: 0;
        }

        100% {
          opacity: 1;
        }
      }
    }
  `}
`;

export const Wrap = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  z-index: 1000;

  @media ${minBp('tabletLarge')} {
    width: 90%;
    left: auto;
    right: -100%;
    animation: slide 0.5s forwards;
    animation-delay: 0.2s;

    @keyframes slide {
      100% {
        right: 0;
      }
    }
  }

  & > svg {
    width: 30px;
    height: 30px;
    padding: 5px;
    top: 10px;
    right: 10px;
    cursor: pointer;
    position: absolute;
  }

  @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    right: 0;
  }
`;
